// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: collapse;
  border: 1px solid #DBE7F1;
}

tr {
  border-top: 1px solid #DBE7F1;
}

th {
  padding: 10px 20px 10px 10px;
  color: #6A8991;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

td {
  background-color: white;
  font-size: 14px;
  padding: 10px 20px 10px 10px;
  font-weight: 500;
}

.link18 {
  color: blue;
  text-decoration: underline;
  font-size: 14px;
}

.font2, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag, option {
  font-family: "Inter";
}

.fontSize10 {
  font-size: 10px;
}

.fontSize11 {
  font-size: 11px;
}

.fontSize12 {
  font-size: 12px;
}

.fontSize13 {
  font-size: 13px;
}

.fontSize14, .ReactTags__selected span.ReactTags__tag, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag {
  font-size: 14px;
}

.fontSize15 {
  font-size: 15px;
}

#outer-container {
  background-color: #F7FAFC;
}

.errorText {
  padding: 5px;
  font-size: 14px;
  color: red;
}

input[type=radio] {
  margin-top: -1px;
}

body {
  font-family: "Inter";
  background-color: #F5F9FF;
  margin: 0;
  padding: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a, a:visited {
  color: #30A9B8;
  text-decoration: none;
}

.extended-table-row-container {
  display: flex;
  background: #113045;
  padding: 20px;
  border: 1px solid #0c424b;
  border-left-width: 0;
  border-right-width: 0;
  min-height: 150px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #d0dbe4;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

::-webkit-scrollbar-thumb {
  background-color: #c0cedc;
  border-radius: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f6f2f2;
}

.container {
  margin: auto;
  width: 50%;
}

.ReactTags__tags {
  position: relative;
  display: flex;
  align-items: flex-start;
}

.timepicker, .timePicker {
  width: 60px !important;
  text-align: center;
}

select, video {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.flexRow {
  display: flex;
  align-items: center;
}

/* Styles for the input */
.ReactTags__tagInput {
  width: 270px;
  border-radius: 2px;
  display: inline-block;
}

.react-tags-wrapper {
  width: 90%;
  box-sizing: border-box;
  border: 1px solid #c3c8ca;
  outline: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.popup-footer {
  height: 50px;
  background-color: #eee;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus {
  height: 31px;
  margin: 0;
  width: 100%;
  border: 0;
  padding-bottom: 2px;
  padding-left: 10px;
  outline: none;
}

/* Styles for selected tags */
.ReactTags__selected {
  outline: none;
  max-width: 500px;
}

.ReactTags__selected span.ReactTags__tag {
  border: 1px solid #ddd;
  background: #eee;
  display: inline-block;
  padding: 5px;
  margin: 3px 5px;
  border-radius: 2px;
}

.ReactTags__selected a.ReactTags__remove {
  color: #aaa;
  margin-left: 5px;
  cursor: pointer;
}

/* Styles for suggestions */
.ReactTags__suggestions {
  position: absolute;
}

.ReactTags__suggestions ul {
  list-style-type: none;
  box-shadow: 0.05em 0.01em 0.5em rgba(0, 0, 0, 0.2);
  background: white;
  width: 200px;
}

.ReactTags__suggestions li {
  border-bottom: 1px solid #ddd;
  padding: 5px 10px;
  margin: 0;
}

.ReactTags__suggestions li mark {
  text-decoration: underline;
  background: none;
  font-weight: 600;
}

.ReactTags__suggestions ul li.ReactTags__activeSuggestion {
  background: #b7cfe0;
  cursor: pointer;
}

.ReactTags__remove {
  border: none;
  cursor: pointer;
  background: none;
}

.tag {
  background-color: #EFF6F8;
  border: 1px solid #B9BEC0;
  border-radius: 4px;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  margin-right: 10px;
}

.tag:hover {
  color: white !important;
  background-color: black !important;
}

.react-confirm-alert-overlay {
  z-index: 9999;
}

.checkbox-primary {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #40A0C1;
  background-color: #FFFFFF;
  position: relative;
  cursor: pointer;
}

.checkbox-primary:checked {
  background-color: #40A0C1;
}

.checkbox-primary:checked::before {
  content: "";
  position: absolute;
  display: block;
  left: 4.5px;
  top: 0.5px;
  width: 3px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.select-primary {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 10px;
}

.radio-primary {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  background-color: #D3E1ED;
  position: relative;
  cursor: pointer;
}

.radio-primary:checked {
  background-color: #40A0C1;
}

.header .top {
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
}
.header .topIconsBox {
  display: flex;
  border-left: 1px solid #3e4e5d;
  padding-left: 30px;
}
.header .topIconWrapper {
  cursor: pointer;
  width: 60px;
  text-align: center;
}
.header .topIconText {
  padding-top: 5px;
  color: #ffffff;
  font-size: 13px;
}
.header .logo {
  width: 150px;
}
.header .header-right-items {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 8px;
}
.header .header-right-items .header-right-search-container {
  position: relative;
  display: flex;
  align-items: center;
  color: #6A8991;
}
.header .header-right-items .header-right-search-container .header-right-search-click-to-open {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  width: 100%;
}
.header .header-right-items .header-right-search-container .header-right-search-input {
  border: 0;
  background-color: transparent;
  outline: none;
  font-size: 14px;
  padding-left: 7px;
  padding: 0 0 0 7px;
}
.header .header-right-items .header-right-search-container .header-right-search-input::placeholder {
  color: #88ABB4;
}
.header .header-right-items .header-right-search-container .header-right-search-results-page-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 8;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container {
  width: 334px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  grid-row-gap: 12px;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container .header-right-search-results-input-area {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  background-color: #F7FAFC;
  border: 1px solid #D3E1ED;
  border-radius: 45px;
  padding: 8px 15px;
  align-items: center;
  color: #6A8991;
  height: 33px;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container .header-right-search-results-input-area .header-right-search-results-select {
  border: 0;
  background-color: transparent;
  font-size: 14px;
  padding: 0;
  outline: none;
  color: #6A8991;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container .header-right-search-results-input-area .header-right-search-results-pipe {
  margin: 0 9px;
  border-right: 1px solid #D3E1ED;
  width: 1px;
  height: 33px;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container .header-right-search-results-dropdown {
  position: absolute;
  top: 42px;
  left: 0;
  z-index: 9;
  background-color: #F5F9FF;
  border-radius: 8px;
  width: 306px;
  border: 1px solid #D3E1ED;
  padding: 14px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.header .header-right-items .header-right-search-container .header-right-search-results-container .header-right-search-results-separator {
  height: 1px;
  width: 100%;
  border: 0;
  padding: 0;
  margin: 5px 0;
  background-color: #B5BFBF;
}
.header .header-menu-icon {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}
.header .header-menu-icon .header-menu {
  position: fixed;
  top: 60px;
  right: 30px;
  background-color: #393939;
  color: white;
  padding: 15px;
  z-index: 999;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.header .header-menu-icon .header-menu .header-menu-item {
  display: flex;
  font-size: 14px;
  column-gap: 10px;
  cursor: pointer;
}
@media (max-width: 765px) {
  .header .top {
    height: 80px;
    padding: 0 5px 0 15px;
  }
  .header .topIconsBox {
    padding-left: 0;
  }
  .header .logo {
    width: 100px;
  }
  .header .topIcon {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/PageBase/Header/header.scss"],"names":[],"mappings":"AAkCA;EACC,yBAAA;EACA,yBAAA;ACjCD;;ADoCA;EACC,6BAAA;ACjCD;;ADoCA;EACC,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;ACjCD;;ADoCA;EACC,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;ACjCD;;ADoCA;EACC,WAAA;EACA,0BAAA;EACA,eAAA;ACjCD;;ADoCA;;EACC,oBAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;;EACC,eAAA;AC/BD;;ADkCA;EACC,eAAA;AC/BD;;ADkCA;EACC,yBAnFO;ACoDR;;ADkCA;EACC,YAAA;EACA,eAAA;EACA,UAAA;AC/BD;;ADkCA;EACC,gBAAA;AC/BD;;ADkCA;EACC,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AC/BD;;ADkCA;EACC,+EAAA;AC/BD;;ADmCA;EACC,cAAA;EACA,qBAAA;AChCD;;ADuCA;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;ACpCD;;ADoDA;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;ACjDD;;ADoDA;EACC,yBAAA;EACA,kBAAA;ACjDD;;ADoDA;EACC,yBAAA;ACjDD;;ADqDA;EACC,YAAA;EACA,UAAA;AClDD;;ADyDA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;ACtDD;;ADyDA;EACC,sBAAA;EACA,kBAAA;ACtDD;;ADyDA;EACC,oCAAA;UAAA,4BAAA;ACtDD;;ADyDA;EACC,aAAA;EACA,mBAAA;ACtDD;;ADyDA,yBAAA;AACA;EACC,YAAA;EACA,kBAAA;EACA,qBAAA;ACtDD;;ADyDA;EACC,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;ACtDD;;ADyDA;EACC,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ACtDD;;ADyDA;;EAIC,YAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;ACxDD;;AD2DA,6BAAA;AACA;EACC,aAAA;EACA,gBAAA;ACxDD;;AD2DA;EAEC,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ACzDD;;AD2DA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;ACxDD;;AD2DA,2BAAA;AACA;EACC,kBAAA;ACxDD;;AD0DA;EACC,qBAAA;EACA,kDAAA;EACA,iBAAA;EACA,YAAA;ACvDD;;ADyDA;EACC,6BAAA;EACA,iBAAA;EACA,SAAA;ACtDD;;ADwDA;EACC,0BAAA;EACA,gBAAA;EACA,gBAAA;ACrDD;;ADuDA;EACC,mBAAA;EACA,eAAA;ACpDD;;ADuDA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;ACpDD;;ADuDA;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;ACpDD;;ADuDA;EACC,uBAAA;EACA,kCAAA;ACpDD;;ADuDA;EACC,aAAA;ACpDD;;ADuDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ACpDD;;ADuDA;EACE,yBAAA;ACpDF;;ADwDA;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;ACrDD;;ADwDA;EACC,gBAAA;EACC,wBAAA;EACA,qBAAA;EAED,yBAAA;EACA,kBAAA;EACC,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;ACtDF;;ADyDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ACtDD;;ADyDA;EACE,yBAAA;ACtDF;;AAnTC;EACC,YDwBa;ECvBb,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAsTF;AAnTC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;AAqTF;AAlTC;EACC,eAAA;EACA,WAAA;EACA,kBAAA;AAoTF;AAjTC;EACC,gBAAA;EACA,cAAA;EACA,eAAA;AAmTF;AAhTC;EACC,YAAA;AAkTF;AA/SC;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAiTF;AA/SE;EACC,kBAAA;EAKA,aAAA;EACA,mBAAA;EACA,cAAA;AA6SH;AA3SG;EACC,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AA6SJ;AA1SG;EACC,SAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA4SJ;AAzSG;EACC,cAAA;AA2SJ;AAxSG;EACC,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AA0SJ;AAvSG;EAQC,YAAA;EAGA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAgSJ;AA9RI;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAgSL;AA9RK;EACC,SAAA;EACA,6BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;AAgSN;AA5RK;EACC,aAAA;EACA,+BAAA;EACA,UAAA;EACA,YAAA;AA8RN;AA1RI;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;AA2RL;AAxRI;EACC,WAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AA0RL;AApRC;EACC,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAsRF;AApRE;EACC,eAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAsRH;AApRG;EACC,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAsRJ;AAjRC;EACC;IACC,YAAA;IACA,qBAAA;EAmRD;EAhRA;IACC,eAAA;EAkRD;EA/QA;IACC,YAAA;EAiRD;EA9QA;IACC,eAAA;EAgRD;AACF","sourcesContent":["// Import the new popup design system\n@import './styles/popup-design-system.scss';\n\n$mobile:  \"(max-width: 765px)\";\n$tablet:  \"(min-width: 766px) and (max-width: 1023px)\";\n$desktop: \"(min-width: 1024px)\";\n\n\n$link: #465bab;\n$menuBg: #071623;\n$appBg: #F7FAFC;\n$mainBg: #F8FAFC;\n$mainTitle: #000000;\n$appBlue: #4070AE;\n$appGreen: #8AC93D;\n$appYellow: #feee96;\n$lightGreen: #AAFFAA;\n$lightBlue: #a5f2ff;\n$glowingBlue: #15d5f7;\n$glowingGreen: #00ffc7;\n$headerIcons: #ffffff;\n$buttonGreen: #8AC93D;\n$appDisabled: #dddddd;\n$lightText: #ddf3f6;\n$disabledText: #455465;\n$webPageBg: #1a4d73d1;\n$transparent: transparent;\n\n$headerHeight: 80px;\n$pageTitleHeight: 80px;\n\n* {\n}\n\ntable {\n\tborder-collapse:collapse;\n\tborder: 1px solid #DBE7F1;\n}\n\ntr {\n\tborder-top: 1px solid #DBE7F1;\n}\n\nth {\n\tpadding: 10px 20px 10px 10px;\n\tcolor: #6A8991;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\ttext-align: left;\n}\n\ntd {\n\tbackground-color: white;\n\tfont-size: 14px;\n\tpadding: 10px 20px 10px 10px;\n\tfont-weight: 500;\n}\n\n.link18 {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tfont-size: 14px;\n}\n\n.font2 {\n\tfont-family: 'Inter';\n}\n\n.fontSize10 {\n\tfont-size: 10px;\n}\n\n.fontSize11 {\n\tfont-size: 11px;\n}\n\n.fontSize12 {\n\tfont-size: 12px;\n}\n\n.fontSize13 {\n\tfont-size: 13px;\n}\n\n.fontSize14 {\n\tfont-size: 14px;\n}\n\n.fontSize15 {\n\tfont-size: 15px;\n}\n\n#outer-container {\n\tbackground-color: $appBg;\n}\n\n.errorText {\n\tpadding: 5px;\n\tfont-size: 14px;\n\tcolor: red;\n}\n\ninput[type=\"radio\"] {\n\tmargin-top: -1px;\n}\n\nbody {\n\tfont-family: 'Inter';\n\tbackground-color: #F5F9FF;\n\tmargin: 0;\n\tpadding: 0;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n\tmonospace;\n}\n\na, a:visited {\n\tcolor: #30A9B8;\n\ttext-decoration: none;\n}\n\noption {\n\t@extend .font2;\n}\n\n.extended-table-row-container {\n\tdisplay: flex;\n\tbackground: #113045;\n\tpadding: 20px;\n\tborder: 1px solid #0c424b;\n\tborder-left-width: 0;\n\tborder-right-width: 0;\n\tmin-height: 150px;\n}\n\n// body::-webkit-scrollbar {\n// \twidth: 10px;\n// }\n\n// body::-webkit-scrollbar-track {\n// \tbox-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n// }\n\n// body::-webkit-scrollbar-thumb {\n// \tbackground-color: $glowingGreen;\n// \toutline: 1px solid slategrey;\n// }\n\n::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: #d0dbe4;\n\tscrollbar-width: thin;\n\tscrollbar-gutter: stable;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #c0cedc;\n\tborder-radius: 6px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground-color: #f6f2f2;\n}\n\n\n.container {\n\tmargin: auto;\n\twidth: 50%;\n}\n.ReactTags__tag {\n\t@extend .font2;\n\t@extend .fontSize14;\n}\n\n.ReactTags__tags {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.timepicker, .timePicker {\n\twidth: 60px !important;\n\ttext-align: center;\n}\n\nselect, video {\n\tuser-select: none !important;\n}\n\n.flexRow {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Styles for the input */\n.ReactTags__tagInput {\n\twidth: 270px;\n\tborder-radius: 2px;\n\tdisplay: inline-block;\n}\n\n.react-tags-wrapper {\n\twidth: 90%;\n\tbox-sizing: border-box;\n\tborder: 1px solid #c3c8ca;\n\toutline: none;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.popup-footer {\n\theight: 50px;\n\tbackground-color: #eee;\n\tborder-top: 1px solid #ddd;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 0 20px;\n}\n\n.ReactTags__tagInput input.ReactTags__tagInputField,\n.ReactTags__tagInput input.ReactTags__tagInputField:focus {\n\t@extend .font2;\n\t@extend .fontSize14;\n\theight: 31px;\n\tmargin: 0;\n\twidth: 100%;\n\tborder: 0;\n\tpadding-bottom: 2px;\n\tpadding-left: 10px;\n\toutline: none;\n}\n\n/* Styles for selected tags */\n.ReactTags__selected {\n\toutline: none;\n\tmax-width: 500px;\n}\n\n.ReactTags__selected span.ReactTags__tag {\n\t@extend .fontSize14;\n\tborder: 1px solid #ddd;\n\tbackground: #eee;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tmargin: 3px 5px;\n\tborder-radius: 2px;\n}\n.ReactTags__selected a.ReactTags__remove {\n\tcolor: #aaa;\n\tmargin-left: 5px;\n\tcursor: pointer;\n}\n\n/* Styles for suggestions */\n.ReactTags__suggestions {\n\tposition: absolute;\n}\n.ReactTags__suggestions ul {\n\tlist-style-type: none;\n\tbox-shadow: .05em .01em .5em rgba(0,0,0,.2);\n\tbackground: white;\n\twidth: 200px;\n}\n.ReactTags__suggestions li {\n\tborder-bottom: 1px solid #ddd;\n\tpadding: 5px 10px;\n\tmargin: 0;\n}\n.ReactTags__suggestions li mark {\n\ttext-decoration: underline;\n\tbackground: none;\n\tfont-weight: 600;\n}\n.ReactTags__suggestions ul li.ReactTags__activeSuggestion {\n\tbackground: #b7cfe0;\n\tcursor: pointer;\n}\n\n.ReactTags__remove {\n\tborder: none;\n\tcursor: pointer;\n\tbackground: none;\n}\n\n.tag {\n\tbackground-color: #EFF6F8;\n\tborder: 1px solid #B9BEC0;\n\tborder-radius: 4px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 5px;\n\tmargin-right: 10px;\n}\n\n.tag:hover {\n\tcolor: white !important;\n\tbackground-color: black !important;\n}\n\n.react-confirm-alert-overlay {\n\tz-index: 9999;\n}\n\n.checkbox-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 2px;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tborder: 1px solid #40A0C1;\n\tbackground-color: #FFFFFF;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.checkbox-primary:checked {\n  background-color: #40A0C1;\n}\n\n\n.checkbox-primary:checked::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tdisplay: block;\n\tleft: 4.5px;\n\ttop: 0.5px;\n\twidth: 3px;\n\theight: 8px;\n\tborder: solid white;\n\tborder-width: 0 2px 2px 0;\n\ttransform: rotate(45deg);\n}\n\n.select-primary {\n\tappearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n\tborder: 1px solid #D3E1ED;\n\tborder-radius: 5px;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 10px;\n}\n\n.radio-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tbackground-color: #D3E1ED;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.radio-primary:checked {\n  background-color: #40A0C1;\n}","@import \"../../../index\";\n\n.header {\n\t.top {\n\t\theight: $headerHeight;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\tpadding: 0 30px;\n\t}\n\n\t.topIconsBox {\n\t\tdisplay: flex;\n\t\tborder-left: 1px solid #3e4e5d;\n\t\tpadding-left: 30px;\n\t}\n\n\t.topIconWrapper {\n\t\tcursor: pointer;\n\t\twidth: 60px;\n\t\ttext-align: center;\n\t}\n\n\t.topIconText {\n\t\tpadding-top: 5px;\n\t\tcolor: #ffffff;\n\t\tfont-size: 13px;\n\t}\n\n\t.logo {\n\t\twidth: 150px;\n\t}\n\n\t.header-right-items {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\talign-items: center;\n\t\tcolumn-gap: 8px;\n\n\t\t.header-right-search-container {\n\t\t\tposition: relative;\n\t\t\t// border: 1px solid #D3E1ED;\n\t\t\t// border-radius: 45px;\n\t\t\t// padding: 8px;\n\t\t\t// width: 230px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcolor: #6A8991;\n\n\t\t\t.header-right-search-click-to-open {\n\t\t\t\tuser-select: none;\n\t\t\t\tcursor: pointer;\n\t\t\t\tdisplay: flex;\n\t\t\t\tfont-size: 18px;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t.header-right-search-input {\n\t\t\t\tborder: 0;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\toutline: none;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding-left: 7px;\n\t\t\t\tpadding: 0 0 0 7px;\n\t\t\t}\n\n\t\t\t.header-right-search-input::placeholder {\n\t\t\t\tcolor: #88ABB4;\n\t\t\t}\n\n\t\t\t.header-right-search-results-page-bg {\n\t\t\t\tposition: fixed;\n\t\t\t\ttop: 0;\n\t\t\t\tbottom: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 0;\n\t\t\t\tz-index: 8;\n\t\t\t}\n\n\t\t\t.header-right-search-results-container {\n\t\t\t\t// position: absolute;\n\t\t\t\t// right: -10px;\n\t\t\t\t// min-height: 100px;\n\t\t\t\t// top: -10px;\n\t\t\t\t// border-radius: 15px;\n\t\t\t\t// padding: 15px 20px;\n\t\t\t\t// z-index: 9;\n\t\t\t\twidth: 334px;\n\t\t\t\t// border: 1px solid #E4E9ED;\n\t\t\t\t// background-color: #EEF1F3;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgrid-row-gap: 12px;\n\n\t\t\t\t.header-right-search-results-input-area {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\tbackground-color: #F7FAFC;\n\t\t\t\t\tborder: 1px solid #D3E1ED;\n\t\t\t\t\tborder-radius: 45px;\n\t\t\t\t\tpadding: 8px 15px;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: #6A8991;\n\t\t\t\t\theight: 33px;\n\n\t\t\t\t\t.header-right-search-results-select {\n\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\toutline: none;\n\t\t\t\t\t\tcolor: #6A8991;\n\t\t\t\t\t\t// width: 47px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.header-right-search-results-pipe {\n\t\t\t\t\t\tmargin: 0 9px;\n\t\t\t\t\t\tborder-right: 1px solid #D3E1ED;\n\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\theight: 33px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.header-right-search-results-dropdown {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 42px;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tz-index: 9;\n\t\t\t\t\tbackground-color: #F5F9FF;\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\twidth: 306px;\n\t\t\t\t\tborder: 1px solid #D3E1ED;\n\t\t\t\t\tpadding: 14px;\n\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\trow-gap: 8px;\n\t\t\t\t}\n\n\t\t\t\t.header-right-search-results-separator {\n\t\t\t\t\theight: 1px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tborder: 0;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 5px 0;\n\t\t\t\t\tbackground-color: #B5BFBF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.header-menu-icon {\n\t\tposition: relative;\n\t\tuser-select: none;\n\n\t\t.header-menu {\n\t\t\tposition: fixed;\n\t\t\ttop: 60px;\n\t\t\tright: 30px;\n\t\t\tbackground-color: #393939;\n\t\t\tcolor: white;\n\t\t\tpadding: 15px;\n\t\t\tz-index: 999;\n\t\t\tborder-radius: 5px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 15px;\n\n\t\t\t.header-menu-item {\n\t\t\t\tdisplay: flex;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolumn-gap: 10px;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media #{$mobile} {\n\t\t.top {\n\t\t\theight: 80px;\n\t\t\tpadding: 0 5px 0 15px;\n\t\t}\n\n\t\t.topIconsBox {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\t.logo {\n\t\t\twidth: 100px;\n\t\t}\n\n\t\t.topIcon {\n\t\t\tfont-size: 16px;\n\t\t}\n\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
